'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _reactUtils = require('react-utils');

var _components = require('I18n/components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var displayName = 'PropertyFormHeader';

var propTypes = {
  centerPropertyForm: _react.PropTypes.bool,
  userTimezone: _react.PropTypes.string.isRequired,
  dateTime: _react.PropTypes.number.isRequired,
  offline: _react.PropTypes.bool.isRequired
};

var PropertyFormHeader = function PropertyFormHeader(_ref) {
  var centerPropertyForm = _ref.centerPropertyForm,
      offline = _ref.offline,
      userTimezone = _ref.userTimezone,
      dateTime = _ref.dateTime;

  var suffix = offline ? 'offline' : 'online';

  var headerClasses = (0, _reactUtils.classNames)('p-x-1 m-bottom-4', {
    'p-x-15 p-top-23': centerPropertyForm
  });

  return _react2.default.createElement(
    'div',
    {
      className: headerClasses,
      'data-timestamp': dateTime,
      'data-selenium-test': 'property-form-header'
    },
    _react2.default.createElement(
      'h4',
      { className: 'm-bottom-3' },
      _react2.default.createElement(_components.FormattedMessage, { message: 'prebook.details.confirm.' + suffix })
    ),
    _react2.default.createElement(
      'h5',
      { className: 'm-bottom-0' },
      dateTime ? _I18n2.default.moment(dateTime).tz(userTimezone).format('LLLL') : ''
    )
  );
};

PropertyFormHeader.displayName = displayName;
PropertyFormHeader.propTypes = propTypes;

exports.default = PropertyFormHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/components/header/PropertyFormHeader.js
// module id = 477
// module chunks = 0